import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { authPassportAtom, isAuthAtom } from 'Recoil/auth.atom';
import { authLogout } from 'Services/auth.services';
import { CartAtom } from 'Recoil/order.atom';
import { Route, Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import { isArray, isNil, map, isEmpty } from 'lodash';
import { fetchCartList } from 'Services/order.services';
import useSession from 'Hooks/session.hook';
import { fetchProductList } from 'Services/inventory.services';
import { HiOutlineOfficeBuilding } from 'react-icons/hi'

import { UserOutlined, ShoppingOutlined } from '@ant-design/icons';
import { Avatar as AntAvatar, Badge, Space, Input, Dropdown, Menu } from 'antd';
import {
  ActionMenu,
  Avatar,
  Notifications,
  Button
} from '@life-line-lab/components-react';

// SERVICE
import { fetchBanners } from 'Services/banner.services';

//components of the navigation bar
import { LanguageSelector } from '@life-line-lab/components-react';
import HamburgerNav from './hamburger-navbar'
import HorizontalNav from './horizontal-nav'
import CategorySelect from './category-menu/category';
import MobileCategory from './category-menu/mobile-category'
import SearchBar from './search-bar/search-bar';
import SearchBar3 from './search-bar/layout3-search'
//css styling imports
import './navbar.scss';
import '@life-line-lab/components-react/build/index.css';
import { useMediaQuery } from 'react-responsive'
import { ControlledDrugOrderButton } from 'Components/shared';

// import './styles/base.scss';

const Protected = ({ children }) => {
  // const isAuth = useRecoilValue<boolean>(isAuthAtom);
  const session = useSession();

  return !isEmpty(session)
    ? <Route children={children} />
    : <Redirect to={{ pathname: '/login' }} />;
};


const NavBar = () => {
  const history = useHistory();
  const location = useLocation();
  // const { profile } = useSession();
  const session = useSession();
  const { Search } = Input;
  // const [isAuth, setIsAuth] = useRecoilState<boolean>(isAuthAtom);
  const [authPassport, setAuthPassport] = useRecoilState<any>(authPassportAtom);
  const [cartState, setCartState] = useRecoilState<any>(CartAtom);

  const [layout3, setLayout3] = useState(false)

  const getBanners = async () => {
    const responseData: any = await fetchBanners({
      filters: { isLandingPage: true, active: true },
      sorting: { sortBy: 'position', mode: 'ASC' }
    });
    if (responseData!.data?.banners[0].layoutStyle === 'TEMPLATE_3') {
      setLayout3(true)
    }
  }

  useEffect(() => {
    getBanners();
  }, [])

  const { t } = useTranslation();
  const isTabletOrMobile = useMediaQuery({ query: `(max-width: 62em)` })

  const menu = [
    // {
    //   label: t("label.trackMyOrder"),
    //   href: '/purchase',
    //   isButton: false,
    //   position: 1
    // },
    // {
    //   label: t("label.customerCare"),
    //   href: '/support',
    //   isButton: false,
    //   position: 2
    // },
    {
      //Language Selector
      isButton: false,
      isLang: true,
      position: 9
    },
    {
      label: t("label.BulkOrder"),
      href: '/corporate',
      isButton: false,
      position: 3
    },
    {
      position: 6,
      customComponent: <ControlledDrugOrderButton />
    },
    {
      href: null,
      isButton: false,
      position: 7,
      hideIfLoggedIn: true,
      hideOnPath: [
        // '/register',
        // '/register-business-account',
      ],
      customComponent: (
        <Dropdown
          trigger={['hover']}
          overlayClassName='signup-dropdown-menu-btn'
          overlayStyle={{ paddingTop: 10 }}
          overlay={(
            <Menu>
              <Menu.Item>
                <div style={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  gap: 8,
                }} onClick={() => { history.push('/register') }}>
                  <UserOutlined /> {t('label.individual')}
                </div>
              </Menu.Item>
              <Menu.Item>
                <div style={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  gap: 8,
                }} onClick={() => { history.push('/register-business-account') }}>
                  <HiOutlineOfficeBuilding /> {t('label.business')}
                </div>
              </Menu.Item>
            </Menu>
          )}>
          <Button
            className="btn-w-100"
            type="secondary"
            label={t('action.signUp')}
            size={!isTabletOrMobile ? 'large' : undefined} // large for desktop, default for mobile
          />
        </Dropdown>
      ),
    },
    {
      label: t('action.login'),
      href: '/login',
      isButton: true,
      type: 'primary',
      location: '/login',
      position: 8
    }
  ]

  const footers = [
    {
      label: t('title.company'),
      position: 4,
      children: [
        {
          label: t('txt.about'),
          fullHypertextRef: 'https://drezy.io/what-we-do'
        },
        {
          label: t('txt.services'),
          fullHypertextRef: 'https://drezy.io/#services'
        },
        {
          label: t('txt.articles'),
          fullHypertextRef: 'https://drezy.io/#articles'
        },
        {
          label: t('txt.businessCentre'),
          fullHypertextRef: process.env.BACKOFFICE_URL
        },
        {
          label: t('txt.appointment'),
          fullHypertextRef: 'https://drezy.io/contact-us?type=2'
        },
      ]
    },
    {
      label: t('title.help'),
      position: 5,
      children: [
        {
          label: t('txt.contactUs'),
          href: '/support'
        },
        {
          label: t('txt.faq'),
          href: '/faq'
        },
        {
          label: t('txt.privacyPolicy'),
          href: '/privacy'
        },
        {
          label: t('txt.terms'),
          href: '/terms'
        },
      ]
    }
  ]

  const handleMenuClick = async (action: string) => {
    switch (action) {
      case 'logout':
        authLogout();
        setAuthPassport({});
        // setIsAuth(false);
        break;

      case 'purchase':
        history.push('/purchase')
        break;

      case 'profile':
        history.push('/profile')
        break;

      default:
        break;
    }
  }

  const onCartClick = () => {
    history.push('/cart');
  }

  useEffect(() => {
    if (session.profile !== undefined) {
      fetchCartListItems()
    }
  }, [])

  useEffect(() => {
    window.scrollTo({
      top: 0,
    })
  }, [])

  const fetchCartListItems = async () => {
    setCartState({ ...cartState, status: { ...cartState.status, fetch: 'loading' } });
    const responseData = await fetchCartList();
    if (!isNil(responseData) && responseData.cartID) {
      setCartState({
        ...cartState,
        status: { ...cartState.status, fetch: 'success' },
        list: responseData.items
      });
    }
    else {
      setCartState({
        ...cartState,
        status: { ...cartState.status, fetch: 'error' }
      });
    }
  }

  return (
    <React.Fragment>

      <div className="navibar">
        <div className='inner-flex-row'>
            {location.pathname !== "/login" && location.pathname !== "/register" ? layout3 ?
              <SearchBar3 /> : <SearchBar /> :
              <div></div> // dummy div for flex grow
            }
          {!layout3 && <div>
            <CategorySelect />
          </div>}
          <div>
            <HorizontalNav isAuth={!isEmpty(session)} menus={menu} location={location} />
          </div>
        </div>
      </div>
      <div className="navibar-mobile">
        <Space direction="horizontal">
          {location.pathname !== "/login" && location.pathname !== "/register" && !layout3 &&
            <SearchBar />
          }
          {location.pathname !== "/login" && location.pathname !== "/register" && <div />
          }
          <MobileCategory />
        </Space>
      </div>
      <div className="buttons -right">
        {!isEmpty(session) &&
          <Space direction="horizontal" size="large">
            <span className="badge shopping-cart" onClick={() => onCartClick()}>
              <Badge count={cartState.list ? cartState.list.length : 0}
                size={isTabletOrMobile ? 'small' : 'default'}
              >
                <AntAvatar style={{ background: 'transparent' }} icon={<ShoppingOutlined />} />
              </Badge>
            </span>

            {/* <Notifications header={t('label.notifications')} notifications={[]} footer="" /> */}

            <ActionMenu
              className="buttons -right profile-action-menu"
              label={<AntAvatar size="large" style={{ background: 'transparent' }} icon={<UserOutlined />} />}
              header={
                <Space direction="horizontal" size="small">
                  <Avatar size="default" style={{ background: 'transparent' }} icon={<UserOutlined />} /> {session.profile && session.profile.fullName}
                </Space>
              }
              actions={[
                {
                  label: t('nav.profile'),
                  onClick: () => handleMenuClick('profile')
                },
                {
                  label: t('nav.myPurchase'),
                  onClick: () => handleMenuClick('purchase')
                },
                {
                  label: t('nav.logout'),
                  onClick: () => handleMenuClick('logout')
                }
              ]}
            />
          </Space>
        }

      </div>

      <div className="navibar-mobile">
        <HamburgerNav isAuth={!isEmpty(session)} menus={menu} footers={footers} location={location} />
      </div>
    </React.Fragment>
  )
}


export default NavBar;
